module.exports = {"511024100":"严陵镇","511024101":"铺子湾镇","511024102":"新店镇","511024103":"向义镇","511024104":"界牌镇","511024105":"龙会镇","511024106":"高石镇","511024107":"东联镇","511024108":"靖和镇","511024109":"镇西镇","511024110":"庆卫镇","511024111":"山王镇","511024112":"黄荆沟镇","511024113":"观英滩镇","511024114":"新场镇","511024115":"连界镇","511024116":"越溪镇","511024117":"两河镇","511024118":"碗厂镇","511024119":"小河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511024.json
// module id = 2143
// module chunks = 0